import React, { useEffect, useState } from 'react';
import { Line, Bar } from 'react-chartjs-2';
import { getTalent } from '../api';

const Talent: React.FC = () => {
  const [data, setData] = useState<any>(null);
  const [error, setError] = useState('');

  // Dummy data for charts
  const satisfactionLabels = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'];
  const headcount = [42, 44, 46, 47, 49, 51, 52];
  const openRoles = [3, 2, 4, 3, 5, 4, 2];
  const attrition = [2, 1, 0, 3, 1, 2, 1];
  const satisfaction = [74, 78, 81, 80, 83, 85, 87];

  useEffect(() => {
    getTalent()
      .then(setData)
      .catch(() => setError('Failed to load talent data'));
  }, []);

  if (error) return <div>{error}</div>;
  if (!data) return <div>Loading...</div>;

  return (
    <div style={{ maxWidth: 1000, margin: '0 auto' }}>
      <h2>Talent</h2>
      <div style={{ display: 'flex', gap: 32, flexWrap: 'wrap', marginBottom: 32 }}>
        <div style={{ flex: 2, minWidth: 320, background: '#fff', borderRadius: 12, boxShadow: '0 2px 12px rgba(0,0,0,0.06)', padding: 24 }}>
          <h3>Headcount Trend</h3>
          <Line
            data={{
              labels: satisfactionLabels,
              datasets: [{
                label: 'Headcount',
                data: headcount,
                borderColor: '#3949ab',
                backgroundColor: 'rgba(57,73,171,0.08)',
                fill: true,
                tension: 0.4,
              }],
            }}
            options={{ plugins: { legend: { display: false } }, scales: { y: { beginAtZero: true } } }}
            height={180}
          />
        </div>
        <div style={{ flex: 1, minWidth: 320, background: '#fff', borderRadius: 12, boxShadow: '0 2px 12px rgba(0,0,0,0.06)', padding: 24 }}>
          <h3>Open Roles</h3>
          <Bar
            data={{
              labels: satisfactionLabels,
              datasets: [{
                label: 'Open Roles',
                data: openRoles,
                backgroundColor: '#ffa000',
              }],
            }}
            options={{ plugins: { legend: { display: false } }, scales: { y: { beginAtZero: true } } }}
            height={180}
          />
        </div>
      </div>
      <div style={{ display: 'flex', gap: 32, flexWrap: 'wrap', marginBottom: 32 }}>
        <div style={{ flex: 1, minWidth: 320, background: '#fff', borderRadius: 12, boxShadow: '0 2px 12px rgba(0,0,0,0.06)', padding: 24 }}>
          <h3>Attrition</h3>
          <Bar
            data={{
              labels: satisfactionLabels,
              datasets: [{
                label: 'Attrition',
                data: attrition,
                backgroundColor: '#e53935',
              }],
            }}
            options={{ plugins: { legend: { display: false } }, scales: { y: { beginAtZero: true } } }}
            height={120}
          />
        </div>
        <div style={{ flex: 2, minWidth: 320, background: '#fff', borderRadius: 12, boxShadow: '0 2px 12px rgba(0,0,0,0.06)', padding: 24 }}>
          <h3>Employee Satisfaction</h3>
          <Line
            data={{
              labels: satisfactionLabels,
              datasets: [{
                label: 'Satisfaction (%)',
                data: satisfaction,
                borderColor: '#43a047',
                backgroundColor: 'rgba(67,160,71,0.08)',
                fill: true,
                tension: 0.4,
              }],
            }}
            options={{ plugins: { legend: { display: false } }, scales: { y: { beginAtZero: true, max: 100 } } }}
            height={120}
          />
        </div>
      </div>
      <div>
        <h2>Talent Metrics</h2>
        <div><strong>Total Employees:</strong> {data.totalEmployees}</div>
        <div><strong>Open Roles:</strong> {data.openRoles}</div>
        <div><strong>Retention Rate:</strong> {data.retentionRate}%</div>
        <div><strong>Recent Hires:</strong> <ul>{data.recentHires.map((h: string, i: number) => <li key={i}>{h}</li>)}</ul></div>
        <div><strong>Engagement Score:</strong> {data.engagementScore}</div>
      </div>
    </div>
  );
};

export default Talent;
